module.exports = __webpack_public_path__ + "assets/phishing.f0e10fe8.svg";